import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Topbar from "./components/Topbar";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import AgentDashboard from "./pages/AgentDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import { Toaster } from "./components/ui/sonner";
import "./App.css";

function Shell({ children }) {
  return (
    <div className="App min-h-screen bg-white text-zinc-950">
      <Topbar />
      {children}
    </div>
  );
}

function App() {
  useEffect(() => {
    document.title = "LeadBridge — Inbound Lead Routing for Insurance Agents";
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Shell><Landing /></Shell>} />
          <Route path="/login" element={<Shell><Login /></Shell>} />
          <Route path="/register" element={<Shell><Register /></Shell>} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Shell><AgentDashboard /></Shell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute role="admin">
                <Shell><AdminDashboard /></Shell>
              </ProtectedRoute>
            }
          />
          <Route path="/payment/success" element={<Shell><PaymentSuccess /></Shell>} />
          <Route path="/payment/cancel" element={<Shell><PaymentCancel /></Shell>} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
